import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BomItem } from '../../models/bom-item.model';

@Injectable({ providedIn: 'root' })
export class AddNodeDropdownProvider {
  constructor(private http: HttpClient) {}

  // the first page of matches in name order (0091) — the user narrows by typing
  searchBomItems(search: string): Observable<BomItem[]> {
    const url = `/api/bom/list`;
    return this.http.get<{ items: BomItem[] }>(url, {
      params: { search }
    }).pipe(map(list => list.items));
  }
}
